import React from 'react';

const ChallengeContext = React.createContext({
  challengeOrigineRoute : ''
})

export default ChallengeContext;
